(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');
    // directive for adding a new task-reaction
    module.directive('taskReactionAdd', ['$rootScope', 'DayTaskBroadcast', 'QuickSidebarTasksService', 
            function ($rootScope, DayTaskBroadcast, QuickSidebarTasksService) {
        var directive = {
            restrict: 'E',
            scope: {
                task: '='
            },
            templateUrl: '/app/tasks/templates/task-reaction-add.template.html',
            controller: 'TaskReactionAddController',
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };
        return directive;

        function link(scope, element) {
            // get abort button
            var abort = element.find('#reaction_abort');
            var save = element.find('#reaction_save');
            var saveAndPin = element.find('#reaction_save_and_pin');

            // if abort-button is clicked
            abort.on('click', function (e) {
                // hide reaction add
                hide();
                $rootScope.$broadcast(DayTaskBroadcast.HideReaction, scope.vm.task.id);
                return false;
            });

            // if save-button is clicked
            save.on('click', function (e) {
                // hide reaction add
                hide();
                $rootScope.$broadcast(DayTaskBroadcast.HideReaction, scope.vm.task.id);
                return false;
            });

            // if save-and-pin-button is clicked
            saveAndPin.on('click', function (e) {
                // hide reaction add
                hide();
                $rootScope.$broadcast(DayTaskBroadcast.HideReaction, scope.vm.task.id);
                return false;
            });

            var showReactionListener = scope.$on(DayTaskBroadcast.ShowReaction, function() {
                hide();
            });

            // hide reactions-add
            function hide() {
                // destroy element
                element.remove();

                // clear
                QuickSidebarTasksService.data.current = null;
            } // hide


            //on destroy
            scope.$on('$destroy', function () {
                abort.off('click');
                save.off('click');

                if (showReactionListener) {
                    showReactionListener();
                    showReactionListener = null;
                }
            });
        }

    }]);

})();